import {
  updateResourceState,
  createResourceReducer,
  RESOURCE
} from 'react-structure-admin';
import {
  STORE_ORDERS,
  STORE_ORDERS_REFRESH,
  STORE_ORDERS_PUT_STATUS,
  STORE_ORDERS_PUT_STATUS_FINISHED,
  STORE_ORDERS_POST_PAYMENT,
  STORE_ORDERS_POST_PAYMENT_FINISHED,
  STORE_ORDERS_GET_PRODUCTS,
  STORE_ORDERS_GET_PRODUCTS_FINISHED,
  STORE_ORDERS_GET,
  STORE_ORDERS_GET_FINISHED,
  STORE_ORDERS_POST_ON_SUCCESS,
  STORE_ORDERS_OPEN_CANCEL,
  STORE_ORDERS_CLOSE_CANCEL,
  STORE_ORDERS_ITEM_OPEN_METADATA,
  STORE_ORDERS_ITEM_CLOSE_METADATA
} from './storeOrderActions';

const storeOrdersReducer = createResourceReducer(
  STORE_ORDERS,
  [],
  {
    [STORE_ORDERS_REFRESH](state, action) {
      return updateResourceState(state, action, RESOURCE, () => ({
        loaded: false
      }));
    },

    [STORE_ORDERS_PUT_STATUS](state, action) {
      return updateResourceState(state, action, RESOURCE, () => ({
        loading: true
      }));
    },

    [STORE_ORDERS_PUT_STATUS_FINISHED](state, action) {
      return updateResourceState(state, action, RESOURCE, () => ({
        loaded: false,
        loading: false,
        cancelingStoreOrderId: null
      }));
    },

    [STORE_ORDERS_POST_PAYMENT](state, action) {
      return updateResourceState(state, action, RESOURCE, () => ({
        loading: true
      }));
    },

    [STORE_ORDERS_POST_PAYMENT_FINISHED](state, action) {
      return updateResourceState(state, action, RESOURCE, () => ({
        loading: false
      }));
    },

    [STORE_ORDERS_GET_PRODUCTS](state, action) {
      return updateResourceState(state, action, RESOURCE, () => ({
        loading: true,
        catching: true
      }));
    },

    [STORE_ORDERS_GET_PRODUCTS_FINISHED](state, action) {
      return updateResourceState(state, action, RESOURCE, () => ({
        loading: false,
        catching: false
      }));
    },

    [STORE_ORDERS_GET](state, action) {
      return updateResourceState(state, action, RESOURCE, () => ({
        loading: action.payload
      }));
    },

    [STORE_ORDERS_GET_FINISHED](state, action) {
      return updateResourceState(state, action, RESOURCE, () => ({
        loading: false
      }));
    },

    [STORE_ORDERS_POST_ON_SUCCESS](state, action) {
      return updateResourceState(state, action, RESOURCE, () => ({
        storeOrder: action.payload
      }));
    },

    [STORE_ORDERS_OPEN_CANCEL](state, action) {
      return updateResourceState(state, action, RESOURCE, () => ({
        cancelingStoreOrderId: action.payload
      }));
    },

    [STORE_ORDERS_CLOSE_CANCEL](state, action) {
      return updateResourceState(state, action, RESOURCE, () => ({
        cancelingStoreOrderId: null
      }));
    },

    [STORE_ORDERS_ITEM_OPEN_METADATA](state, action) {
      return updateResourceState(state, action, RESOURCE, () => ({
        activeModal: STORE_ORDERS_ITEM_OPEN_METADATA,
        item: action.payload.item
      }));
    },

    [STORE_ORDERS_ITEM_CLOSE_METADATA](state, action) {
      return updateResourceState(state, action, RESOURCE, () => ({
        activeModal: null,
        item: null
      }));
    }
  },

  (state, action) => {
    return updateResourceState(state, action, RESOURCE, () => ({
      loading: false,
      catching: false,
      storeOrder: null
    }));
  }
);

export default storeOrdersReducer;
